/*
 * Copyright (c) ProviderTrust LLC.
 * All Rights Reserved.
 *
 * This software is confidential and proprietary information of
 * ProviderTrust LLC ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with ProviderTrust.
 */

export const upper = (str = "") => str.toUpperCase()

export const sortName = (descending = false) => (descending ? "desc" : "asc")



// WEBPACK FOOTER //
// ./src/service/filters.js